import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import getters from './getters'
import * as actions from './actions'

import campaign from './modules/campaign'
import notice from './modules/notice'
import promotion from './modules/promotion'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    campaign,
    notice,
    promotion
  },
  state: {
    loginStatus: 999,
    dashboardData: {
      top: {},
      bottom: {}
    }, // --> Dashboard
    getStatus: false,
    campaignList_0: [], // --> 전체 캠페인 리스트 use
    campaignList_1: [], // --> 예정 캠페인 리스트 use
    campaignList_2: [], // --> 진행 캠페인 리스트 use
    campaignList_3: [], // --> 홀딩 캠페인 리스트 use
    campaignList_4: [], // --> 완료 캠페인 리스트 use
    campaignList_5: [], // --> 중간정산 캠페인 리스트 use
    campaignListStatus: 2, // --> 캠페인 리스트 분류 use
    listOrderType: 'desc', // --> 캠페인 리스트 정렬 타입 sue
    listSortKey: 'campaign_fr_ymd', // --> 캠페인 리스트 정렬 키 sue
    searchList: {
      data: [],
      info: 0
    },   // --> 검색 결과 use
    searchKey: '', // --> 검색 키워드 use
    currentPage: 1   // --> pagination num use
    // isViewGangnam: false
  },
  mutations,
  getters,
  actions
})



// WEBPACK FOOTER //
// ./src/vuex/store.js